import gql from 'graphql-tag';
import { PayPeriodFragment } from './PayPeriodQueries';

const CLOSE_PAY_PERIOD = gql`
  mutation ClosePayPeriod($input: PayPeriodCloseInput!) {
    pay_period_close(input: $input) {
      ...PayPeriodFragment
    }
  }
  ${PayPeriodFragment}
`;

export const payPeriodCloseApi = (client, payPeriodId) => {
  const variables = {
    input: {
      pay_period_id: payPeriodId,
    },
  };

  const options = {
    mutation: CLOSE_PAY_PERIOD,
    variables,
  };

  return client.mutate(options);
};

const FINALIZE_PAY_PERIOD = gql`
  mutation FinalizePayPeriod($input: PayPeriodFinalizeInput!) {
    pay_period_finalize(input: $input) {
      ...PayPeriodFragment
    }
  }
  ${PayPeriodFragment}
`;

export const payPeriodFinalizeApi = (client, payPeriodId) => {
  const variables = {
    input: {
      pay_period_id: payPeriodId,
    },
  };

  const options = {
    mutation: FINALIZE_PAY_PERIOD,
    variables,
  };

  return client.mutate(options);
};

const OPEN_PAY_PERIOD = gql`
  mutation OpenPayPeriod($input: PayPeriodOpenInput!) {
    pay_period_open(input: $input) {
      ...PayPeriodFragment
    }
  }
  ${PayPeriodFragment}
`;

export const payPeriodOpenApi = (client, payPeriodId) => {
  const variables = {
    input: {
      pay_period_id: payPeriodId,
    },
  };

  const options = {
    mutation: OPEN_PAY_PERIOD,
    variables,
  };

  return client.mutate(options);
};
